module.exports = __webpack_public_path__ + "img/logo_l.90e6e8e4.png";